(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.setAttribute('data-open', String(!open));
    });
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        main.alt = b.getAttribute('data-alt') || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });

  // Watch ID validation on product form
  document.querySelectorAll('form[data-watch-form]').forEach(function (form) {
    var input = form.querySelector('[data-watch-id]');
    if (!input) return;
    var field = input.closest('.field'); form.noValidate = true;
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\s+/g, '');
      if (field) field.setAttribute('data-invalid', 'false');
    });
    form.addEventListener('submit', function (ev) {
      var v = input.value.trim();
      if (!/^\S{20}$/.test(v)) {
        ev.preventDefault();
        if (field) field.setAttribute('data-invalid', 'true');
        input.focus();
      }
    });
  });

  // Cart quantity auto-submit
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    q.addEventListener('change', function () { q.form && q.form.submit(); });
  });
})();
